export const levelDisplay = {
  error: { color: 'error', icon: 'fire' },
  warning: { color: 'warning', icon: 'triangle-exclamation' },
  ok: { color: 'success', icon: 'check' },
};

export const stateDisplay = {
  up: levelDisplay.ok,
  ok: levelDisplay.ok,
  critical: levelDisplay.error,
  unreachable: levelDisplay.error,
  warning: levelDisplay.warning,
  down: { color: 'error', icon: 'xmark' },
  unknown: { color: 'regular', icon: 'question' },
};

export const statePriority = {
  down: 0,
  critical: 1,
  unreachable: 2,
  warning: 3,
  unknown: 4,
  up: 5,
  ok: 6,
};

export const statesByLevel = {
  error: ['critical', 'down', 'unreachable'],
  warning: ['unknown', 'warning'],
  ok: ['up', 'ok'],
};

// An item without an alert state is operational: the API's `alert` filter only checks that a
// notification is attached, and a notification can be a recovery or carry no state at all.
export const isProblemState = (state) => !statesByLevel.ok.includes(state || 'ok');
